import { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { useAppVersionGate } from "@/hooks/useAppVersionGate";
import MandatoryUpdateScreen from "@/components/MandatoryUpdateScreen";

export default function AppVersionGate({ children }: { children: ReactNode }) {
  const { status, currentVersion, config } = useAppVersionGate();

  const publicPath = typeof window !== "undefined" ? window.location.pathname : "";
  const isPublicRoute =
    publicPath === "/driver/privacy" ||
    publicPath === "/driver/terms" ||
    publicPath === "/driver/delete-account";

  if (isPublicRoute) return <>{children}</>;

  if (status === "checking") {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      </div>
    );
  }

  if (status === "update_required" && config) {
    return <MandatoryUpdateScreen currentVersion={currentVersion} config={config} />;
  }

  return <>{children}</>;
}